import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AppUser } from 'app/models/app-user';
import { UserService } from 'app/shared/services/User/user.service';
import { MatDialog } from '@angular/material';
import { ResetPasswordModelComponent } from './reset-password-model/reset-password-model.component';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})

export class WelcomeComponent implements OnInit {
  user: AppUser;
  loginForm: FormGroup;
  registerForm: FormGroup;
  showRegisterForm: Boolean = false;
  loading: boolean;
  groupId: any;

  publicGroupId;

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private data: DataSharingService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.data.currentGroupId.subscribe(groupId => this.groupId = groupId);
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)])
    });
    this.registerForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      firstName: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)]),
      checkBox: new FormControl('', Validators.required)
    });
    this.route.queryParams.subscribe(params => {
      this.publicGroupId = Number(params.publicGroupId);
    });
  }

  createAccount(value) {
    this.showRegisterForm = value;
  }

  signInFacebook() {
    this.userService.initFbSignIn();
  }

  signUpEmailPassword() {
    this.markFormGroupTouch(this.registerForm);
    if (this.registerForm.valid && this.registerForm.get('checkBox').value) {
      this.loading = true;
      this.userService.signUpUserByEmail(this.registerForm.value).then(res => {
        if (res === false) {
          this.showRegisterForm = false;
        }
        this.loading = false;
        if (Number.isInteger(this.publicGroupId)) {
          this.router.navigate(['new-group/public-groups/view-detail'], { queryParams: { groupId: this.publicGroupId } });
        } else {
          this.router.navigateByUrl('/new-group');
        }
      });
    }
  }

  signInEmail() {
    this.markFormGroupTouch(this.loginForm);
    if (this.loginForm.valid) {
      this.loading = true;
      this.userService.loginUser(this.loginForm.value, this.groupId).then(res => {
        this.loading = false;
        if (this.userService.user.req_onboarding.indexOf('onboard_group') != -1) {
          // no groups
          this.router.navigateByUrl('/new-group');
        } else if (Number.isInteger(this.publicGroupId)) {
          this.router.navigate(['new-group/public-groups/view-detail'], { queryParams: { groupId: this.publicGroupId } });
        } else {
          // has a group 
          this.router.navigateByUrl('/groups');
        }
      }, err => {
        this.loading = false; 
        // error logging in
      });
    }
  }

  resetPassword() {
    this.dialog.open(ResetPasswordModelComponent, {
      width: '400px',
    });
  }

  private markFormGroupTouch(form: FormGroup) {
    (<any>Object).values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouch(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/welcome/welcome.component.ts